<app-side-dialog data-testid="admin-user-feedback-details-dialog" (closeDialog)="onClose()">
  <div dialogHeader>
    <h2 class="text-xl font-semibold">{{ 'pages.admin.userFeedback.detailsTitle' | translate }}</h2>
  </div>

  <div dialogContent class="space-y-6 pb-6">
    @if (imageUrl()) {
      <button
        type="button"
        class="group relative block border border-gray-200 rounded-lg min-h-[574px] overflow-hidden focus-visible:outline-none"
        (click)="onImageClick()"
      >
        <img [src]="imageUrl()" alt="Screenshot" class="w-full object-contain" />
        <div
          class="pointer-events-none absolute inset-0 flex items-center justify-center bg-black/50 opacity-0 transition-opacity group-hover:opacity-100"
        >
          <div class="flex items-center gap-1">
            <app-icon src="/icons/magnify.svg" alt="search icon" class="invert w-4 h-4" />
            <span class="text-sm font-medium text-white">{{ 'shared.zoom' | translate }}</span>
          </div>
        </div>
      </button>
    } @else if (imageUrl() === undefined && data.feedback.imageId) {
      <ngx-skeleton-loader class="w-[1150px] h-[574px]" [theme]="{ width: '1150px', height: '574px' }" />
    }

    <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
      <div>
        <p class="text-xs font-semibold uppercase text-gray-500">ID</p>
        <p class="break-words">{{ data.feedback.id ?? '-' }}</p>
      </div>
      <div>
        <p class="text-xs font-semibold uppercase text-gray-500">{{ 'shared.bugReport.type' | translate }}</p>
        <p>{{ 'shared.userFeedbackTypes.' + (data.feedback.type | lowercase) | translate }}</p>
      </div>
      <div>
        <p class="text-xs font-semibold uppercase text-gray-500">{{ 'shared.status' | translate }}</p>
        <p>{{ 'shared.userFeedbackStatuses.' + (data.feedback.status | lowercase) | translate }}</p>
      </div>
      <div>
        <p class="text-xs font-semibold uppercase text-gray-500">{{ 'shared.userGroupId' | translate }}</p>
        <p>{{ data.feedback.userGroupId ?? '-' }}</p>
      </div>
      <div>
        <p class="text-xs font-semibold uppercase text-gray-500">{{ 'shared.createdAt' | translate }}</p>
        <p>
          {{ data.feedback.createdAtDate ? (data.feedback.createdAtDate | date: 'dd.MM.yyyy HH:mm') : '-' }}
        </p>
      </div>
      <div>
        <p class="text-xs font-semibold uppercase text-gray-500">{{ 'shared.createdBy' | translate }}</p>
        <p>
          {{ creatorName() ?? '-' }}
        </p>
      </div>
      <div class="md:col-span-2">
        <p class="text-xs font-semibold uppercase text-gray-500">
          {{ 'pages.admin.userFeedback.currentUrl' | translate }}
        </p>
        <a
          class="break-all hover:underline"
          [href]="data.feedback.currentUrl"
          target="_blank"
          rel="noopener noreferrer"
        >
          {{ data.feedback.currentUrl }}
        </a>
      </div>
      <div>
        <p class="text-xs font-semibold uppercase text-gray-500">
          {{ 'pages.admin.userFeedback.browserInfo' | translate }}
        </p>
        <p class="break-words">{{ data.feedback.browserInfo }}</p>
      </div>
      <div>
        <p class="text-xs font-semibold uppercase text-gray-500">
          {{ 'pages.admin.userFeedback.screenResolution' | translate }}
        </p>
        <p>{{ data.feedback.screenResolution }}</p>
      </div>
    </div>

    <div>
      <p class="text-xs font-semibold uppercase text-gray-500">{{ 'shared.bugReport.message' | translate }}</p>
      <p class="whitespace-pre-line">{{ data.feedback.message }}</p>
    </div>
  </div>
</app-side-dialog>
